import React from "react";
import { Box } from "@mui/material";
import useStyles from "assets/jss/material-react/views/italmundoStyles";

export function Redireccion() {
  const classes = useStyles();
  return (
    <Box className={classes.modalContentDynamic}>
      <h3 className={classes.modalTitle}>Este paso ya se completó</h3>
      <p className={classes.modalMessage}>¡Te estamos redirigiendo!</p>
    </Box>
  );
}

export default Redireccion;
